import MarkerClusterer from "@google/markerclusterer";
import get from "lodash-es/get";
import isString from "lodash-es/isString";
import isArray from "lodash-es/isArray";
import markerImage from "../../images/Location.svg";
import markerCluster from "../../images/Cluster.svg";
import CompanyInfo from "./CompanyInfo.vue";
import find from "lodash-es/find";

const CompanyInfoVue = Vue.extend(CompanyInfo);

class Map {
  constructor() {
    this.map = null;
    this.clusterer = null;
    this.markers = [];
    this.infoWindows = [];
  }

  create(element, center) {
    let mapCenter = center,
      zoom = 12;

    if (isString(mapCenter)) {
      let [lat, lng] = mapCenter.split(",");
      lat = parseFloat(lat);
      lng = parseFloat(lng);
      mapCenter = { lat, lng };
    }

    let styles = [
      {
        elementType: "geometry",
        stylers: [
          {
            color: "#f5f5f5",
          },
        ],
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#f5f5f5",
          },
        ],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#bdbdbd",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#e5e5e5",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
      {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [
          {
            color: "#e5e5e5",
          },
        ],
      },
      {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#c9c9c9",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
    ];

    this.map = new google.maps.Map(element, {
      center: mapCenter,
      zoom: zoom,
      // disableDefaultUI: true,
      scrollwheel: false,
      styles: [],
      //styles, //disable old styles
    });

    this.clusterer = new MarkerClusterer(this.map, this.markers, {
      maxZoom: 15,
      averageCenter: true,
      imagePath: markerCluster,
      styles: [
        {
          url: markerCluster,
          textColor: "white",
          height: 34,
          width: 34,
          textSize: 12,
        },
      ],
      //imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      // styles: [{
      // 	url: MAP.cluster_icon,
      // 	textColor: 'white',
      // 	height: 60,
      // 	width: 60,
      // 	textSize: 20
      // }]
    });
  }

  setItems(items, filterParams) {
    this.clear();
    let bounds = new google.maps.LatLngBounds();
    items.forEach((item) => {
      let marker = this.addMarker(item);

      if (!marker) {
        return;
      }

      bounds.extend(marker.getPosition());
    });

    if (!bounds.isEmpty()) {
      this.map.fitBounds(bounds);
    } else {
      const [lat, lng] = filterParams.location.latlng.split(",");
      this.map.setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) });
    }
  }

  addMarker(item) {
    let latlng = get(item, "location.latlng");
    if (!isArray(latlng) && !latlng) {
      return;
    }

    if (isString(latlng)) {
      latlng = latlng.split(",");
    }

    let marker = new google.maps.Marker({
      position: new google.maps.LatLng(latlng[0], latlng[1]),
      icon: markerImage,
      map: this.map,
      title: item.title,
      item,
    });

    let infoElement = new CompanyInfoVue({
        propsData: { company: item },
      }).$mount(),
      infoWindow = new google.maps.InfoWindow({
        content: infoElement.$el,
        marker,
        item,
      });

    marker.addListener("click", () => {
      this.openInfoWindow(infoWindow);
    });

    this.markers.push(marker);
    this.infoWindows.push(infoWindow);
    this.clusterer.addMarker(marker);

    return marker;
  }

  clear() {
    this.markers.forEach((marker) => marker.setMap(null));
    if(this.clusterer) this.clusterer.removeMarkers(this.markers);
    this.markers = [];
  }

  openInfoWindow(infoWindow) {
    this.infoWindows.forEach((w) => w.close());
    infoWindow.open(this.map, infoWindow.marker);
  }

  openItem(item) {
    let infoWindow = find(this.infoWindows, (iw) => iw.item === item);

    if (!infoWindow) {
      return;
    }

    this.openInfoWindow(infoWindow);
  }
}

export default Map;
